<template>
  <div class="w-full flex flex-col gap-1 p-1 rounded-xl" style="background-color: #10111A">
    <img :src="asset" class="w-full rounded-lg" style="aspect-ratio: 1/1;">
    <div class="w-full flex flex-col">
      <div class="w-full flex items-center p-2">
        <AdRankIcon class="text-neutral-alpha-650" />
        <BaseText type="body" size="sm" class="text-neutral-alpha-650 pl-2">
          Rank
        </BaseText>
        <BaseText type="label" size="sm" class="text-white ml-auto">
          #{{ rank }}
        </BaseText>
        <BaseText type="body" size="sm" class="text-neutral-alpha-700 ml-2 pr-1">
          of {{ totalAds }}
        </BaseText>
      </div>
      <div class="w-full flex items-center p-2">
        <PercentileIcon class="text-neutral-alpha-650" />
        <BaseText type="body" size="sm" class="text-neutral-alpha-650 pl-2">
          Percentile
        </BaseText>
        <BaseText type="body" size="sm" class="text-neutral-alpha-700 ml-auto pr-1">
          {{ percentileStr }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import AdRankIcon from '@/components/globals/Icons/SpyderModeIcons/AdRankIcon.vue'
import PercentileIcon from '@/components/globals/Icons/PercentileIcon.vue'

export default {
  name: 'InfoPreviewCard',
  components: {
    AdRankIcon,
    PercentileIcon
  },
  props: {
    asset: {
      type: String,
      required: true
    },
    rank: {
      type: Number,
      required: true
    },
    totalAds: {
      type: Number,
      required: true
    },
    percentileStr: {
      type: String,
      required: true
    }
  }
}
</script>